module.exports = __webpack_public_path__ + "static/media/Carousel Image 4.69c73972.png";